import {animate, state, style, transition, trigger} from '@angular/animations';

export const CollapseMenuUtilitiesAnimation = trigger('collapseUtilities', [
  state('false',
  style(
    { maxWidth: 'calc(100% - 65px)', minWidth: 'calc(100% - 65px)', left: '65px' }
  )),
  state('true',
    style(
      { maxWidth: '50px', backgroundColor: '#F6F6FB' }
  )),
  transition(
    'false => true',
    animate('0.1s') // 0.10
  ),
  transition(
    'true => false',
    animate('0.1s')
  )
]);

export const CollapseNavigationsUtilitiesAnimation = trigger('collapseNavigations', [
  state('show',
  style(
    { maxWidth: '470px', minWidth: '470px', backgroundColor: '#FFF'}
  )),
  state('hide',
    style(
      { maxWidth: '135px', minWidth: '135px', backgroundColor: '#F6F6FB' }
  )),
  transition(
    'show => hide',
    animate('0.10s')
  ),
  transition(
    'hide => show',
    animate('0.10s') // 0.10
  )
]);

export const HideMenuUtilitiesAnimation = trigger('hideUtilities', [
  state('false',
  style(
    { left: '0', opacity: 1 }
  )),
  state('true',
    style(
      {opacity: 0, left: '-120%' }
  )),
  transition(
    'false => true',
    animate('0.10s') // 0.10
  ),
  transition(
    'true => false',
    animate('0.10s') // 0.20
  )
]);
